var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 0.333313C7.46089 0.333313 7.83398 0.706409 7.83398 1.16665V6.16665H12.834C13.2942 6.16665 13.6673 6.53974 13.6673 6.99998C13.6673 7.46022 13.2942 7.83331 12.834 7.83331H7.83398V12.8333C7.83398 13.2935 7.46089 13.6666 7.00065 13.6666C6.54041 13.6666 6.16732 13.2935 6.16732 12.8333V7.83331H1.16732C0.70708 7.83331 0.333984 7.46022 0.333984 6.99998C0.333984 6.53974 0.70708 6.16665 1.16732 6.16665H6.16732V1.16665C6.16732 0.706409 6.54041 0.333313 7.00065 0.333313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.29fece6c.svg";
export { ForwardRef as ReactComponent };